import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useLocale } from '../../context/LocaleContext';
import '../../styles/reports.css';

/**
 * Custio-style main region: light rounded panel on dark outer chrome.
 * variant="reports" — Bonnie-style analytics (bold title, purple accents, white cards).
 */
export default function MainPanel({ title, subtitle, actions, children, variant }) {
  const { t } = useLocale();
  const isReports = variant === 'reports';
  const panelClass = isReports ? 'custio-panel custio-panel--reports' : 'custio-panel';

  return (
    <div className="custio-main">
      <div className={panelClass}>
        <header className="custio-panel__head">
          <div>
            <h1 className="custio-panel__title">{title}</h1>
            {subtitle && (
              isReports ? (
                <p className="custio-panel__subtitle">{subtitle}</p>
              ) : (
                <p style={{ margin: '6px 0 0', fontSize: 14, color: '#9ca3af' }}>{subtitle}</p>
              )
            )}
          </div>
          {actions}
        </header>
        <div className="custio-panel__body">{children}</div>
      </div>
      <button
        type="button"
        className="custio-fab"
        aria-label={t('shell.supportChatAria')}
        title={t('common.chat')}
      >
        <MessageCircle size={22} strokeWidth={1.75} />
      </button>
    </div>
  );
}
